import React from 'react';
import { content } from '../../content';
import { sortedPosts } from '../../utils/blog';
import BlogCard from '../blog/BlogCard';
import BlogPostView from '../blog/BlogPostView';
import '../../styles/Blog.css';

const { blog } = content;

type BlogSectionProps = {
  /** From the hash: `#/blog/<id>`. Null while the feed is showing. */
  postId: string | null;
  onOpen: (postId: string) => void;
  onBack: () => void;
};

/**
 * Two states behind one nav entry: the feed of cards, and the open article.
 * Which one shows is decided by the URL, not by component state, so a shared
 * link opens the article and the back button returns to the feed.
 *
 * An id in the hash that matches nothing falls back to the feed rather than
 * to an error — a renamed post should cost a reader a click, not a dead end.
 */
const BlogSection = ({ postId, onOpen, onBack }: BlogSectionProps) => {
  const posts = sortedPosts(blog.posts);
  const open = postId ? posts.find((post) => post.id === postId) : null;

  if (open) return <BlogPostView post={open} onBack={onBack} />;

  if (posts.length === 0) {
    return (
      <div className="section">
        <p className="reviews__caption">{blog.empty}</p>
      </div>
    );
  }

  return (
    <div className="section">
      <ul className="feed">
        {posts.map((post) => (
          <BlogCard key={post.id} post={post} onOpen={() => onOpen(post.id)} />
        ))}
      </ul>
    </div>
  );
};

export default BlogSection;
